import { ExternalLink } from "lucide-react";

import { EXTERNAL_LINKS } from "@/config/externalLinks";

export function AboutPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6 sm:py-16">
      <h1 className="mb-6 font-display text-3xl font-medium sm:text-4xl">このアプリについて</h1>

      <section className="mb-10 space-y-4 leading-relaxed text-[var(--color-ink-muted)]">
        <p>
          <strong className="text-[var(--color-ink)]">PPTX JSON Studio</strong>
          は、PowerPoint と PDF の中身を、誰でも触れる JSON
          とレイアウト構造として開放する技術紹介アプリです。
        </p>
        <p>
          AI
          が資料を編集・生成できる時代になりましたが、その内部で何が起きているかは普通は見えません。このアプリは、
          <strong className="text-[var(--color-ink)]">JSON という中間フォーマット</strong>
          とページの<strong className="text-[var(--color-ink)]">レイアウト解析</strong>
          を介して、AI
          に自然言語で資料を編集させたり、構造を理解させたりするワークフローを体感できるようにしたものです。
        </p>
        <p>
          PowerPoint はスライドごとに JSON へ分解し、コピーして ChatGPT / Gemini
          で編集し、復元画面に流せば .pptx に戻せます。PowerPoint・PDF
          はページのレイアウト（テキスト・図表・写真の位置と種別）を解析でき、PDF からは編集可能な
          PowerPoint を新規生成することもできます。
        </p>
      </section>

      <section className="mb-10">
        <h2 className="mb-4 font-display text-2xl font-medium">技術詳細に興味がある方へ</h2>
        <p className="mb-4 text-[var(--color-ink-muted)]">
          実装の背景は次の Qiita 記事にまとめています。
        </p>
        <ul className="space-y-3">
          {EXTERNAL_LINKS.qiita.map((link) => (
            <li key={link.url}>
              <a
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-start gap-2 rounded-[10px] border border-[var(--color-border)] bg-[var(--color-surface)] p-4 transition hover:bg-[var(--color-surface-muted)]"
              >
                <div className="flex-1">
                  <div className="font-display text-lg font-medium text-[var(--color-ink)] group-hover:underline">
                    {link.title}
                  </div>
                  <div className="mt-1 text-sm text-[var(--color-ink-muted)]">{link.summary}</div>
                </div>
                <ExternalLink size={16} className="mt-1 text-[var(--color-ink-muted)]" />
              </a>
            </li>
          ))}
        </ul>
      </section>

      <section className="mb-10">
        <h2 className="mb-4 font-display text-2xl font-medium">プライバシー</h2>
        <ul className="list-disc pl-5 text-[var(--color-ink-muted)]">
          <li>
            アップロードされた .pptx / .pdf
            はサーバに保存されません。メモリ上で処理後に破棄されます。
          </li>
          <li>変換・解析した JSON は、お使いのブラウザの中だけに存在します。</li>
          <li>AI 編集機能はパスワード認証で保護されており、誰でも自由には使えません。</li>
        </ul>
      </section>
    </div>
  );
}
